import { PropsWithChildren } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Skeleton } from '@/components/ui/skeleton'
import TeamContext from '../../../config/context/team'
import GuildContext from '../../../config/context/guild'
import { getTeamDetails } from '../../../api/team'
import useReferenceStore from '../../../state/useReferenceStore'

interface Props {
  guild: wowaudit.Guild
  guildReference?: wowaudit.GuildReference
  createdTeam: wowaudit.TeamReference
}

const OnboardingTeamProvider = ({
  guild,
  guildReference,
  createdTeam,
  children,
}: PropsWithChildren<Props>) => {
  const { storeReferences } = useReferenceStore()

  const { data: team, refetch } = useQuery({
    queryKey: ['team', { path: createdTeam.path }],
    queryFn: async () => {
      const response = await getTeamDetails(createdTeam.id)
      storeReferences([
        response.ownerReference,
        ...(response.members?.map((member) => member.characterReference) ?? []),
      ])
      return response
    },
    staleTime: 1000 * 60 * 60,
  })

  if (!team) {
    return <Skeleton className='h-64' />
  }

  return (
    <GuildContext.Provider
      value={{
        guild,
        guildReference,
        currentTeam: team,
        teamReference: createdTeam,
      }}
    >
      <TeamContext.Provider
        value={{ guild, team, refetchTeamDetails: refetch }}
      >
        {children}
      </TeamContext.Provider>
    </GuildContext.Provider>
  )
}

export default OnboardingTeamProvider
